import React, { useEffect, useState } from 'react';

// chakra imports
import {
   Box,
   Flex,
   Drawer,
   DrawerBody,
   Icon,
   useColorModeValue,
   DrawerOverlay,
   useDisclosure,
   DrawerContent,
   DrawerCloseButton,
   useBreakpointValue,
   useColorMode,
} from '@chakra-ui/react';
import Content from 'components/sidebar/components/Content';
import { renderThumb, renderTrack, renderView } from 'components/scrollbar/Scrollbar';
import { Scrollbars } from 'react-custom-scrollbars-2';
import PropTypes from 'prop-types';
import { useUser } from 'contexts';

// Assets
import { AiOutlineMenuFold } from 'react-icons/ai';
import { useLocation } from 'react-router-dom';

function Sidebar(props) {
   const { routes, isSidebarOpen } = props;
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';
   // const [isSidebarOpen, setIsSidebarOpen] = useState(true);
   let variantChange = '0.2s linear';
   let shadow = useColorModeValue('14px 17px 40px 4px rgba(112, 144, 176, 0.08)', 'unset');
   let sidebarMargins = '0px';

   // if (!isSidebarOpen) return null;

   // SIDEBAR
   return (
      <Box
         // display={{ sm: 'none', xl: isSidebarOpen ? 'none' : 'block' }}
         display={{ sm: 'none', xl: 'block' }}
         // w="100%"
         position="fixed"
         top="0"
         left="0"
         minH="100%">
         <Box
            bg={`${isDark ? '#16213E' : 'white'}`}
            transition={variantChange}
            w="250px"
            h="100vh"
            m={sidebarMargins}
            minH="100%"
            overflowX="hidden"
            boxShadow={shadow}>
            <Scrollbars
               autoHide
               renderTrackVertical={renderTrack}
               renderThumbVertical={renderThumb}
               renderView={renderView}>
               <Content routes={routes} />
            </Scrollbars>
         </Box>
      </Box>
   );
}

// FUNCTIONS
export function SidebarResponsive(props) {
   const { isOpen, onOpen, onClose } = useDisclosure();
   const location = useLocation();
   let sidebarBackgroundColor = useColorModeValue('white', 'navy.800');
   let menuColor = useColorModeValue('gray.800', 'white');
   // // SIDEBAR
   const btnRef = React.useRef();
   const prevPathRef = React.useRef(location.pathname);
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';

   const { routes } = props;

   // let isWindows = navigator.platform.startsWith("Win");
   //  BRAND
   useEffect(() => {
      if (isOpen && prevPathRef.current !== location.pathname) {
         // Update the previous path reference first
         prevPathRef.current = location.pathname;

         // Close the sidebar
         onClose();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [location.pathname]);

   return (
      <Flex display={{ sm: 'flex', xl: 'none' }} alignItems="center" mb={''}>
         <Flex ref={btnRef} w="max-content" h="max-content" onClick={onOpen}>
            <AiOutlineMenuFold size={25} />
         </Flex>
         <Box mb={''} bg={`${isDark ? '#16213E' : 'white'}`}>
            <Drawer
               isOpen={isOpen}
               onClose={onClose}
               placement={document.documentElement.dir === 'rtl' ? 'right' : 'left'}
               finalFocusRef={btnRef}
               motionPreset="slideInLeft">
               <DrawerOverlay />
               <DrawerContent w="250px" maxW="250px" bg={`${isDark ? '#16213E' : 'white'}`} h="100vh">
                  <DrawerCloseButton zIndex="3" _focus={{ boxShadow: 'none' }} _hover={{ boxShadow: 'none' }} />
                  <DrawerBody maxW="250px" px="0rem" pb="0" h="100vh">
                     <Scrollbars
                        autoHide
                        renderTrackVertical={renderTrack}
                        renderThumbVertical={renderThumb}
                        renderView={renderView}>
                        <Content routes={routes} onClose={onClose} />
                     </Scrollbars>
                  </DrawerBody>
               </DrawerContent>
            </Drawer>
         </Box>
      </Flex>
   );
}
// PROPS

Sidebar.propTypes = {
   logoText: PropTypes.string,
   routes: PropTypes.arrayOf(PropTypes.object),
   variant: PropTypes.string,
};

export default Sidebar;
